import { baseClient } from '../common';
import { RegisterNotificationTokenModel } from './register-notification-token.model';
import { UnregisterNotificationTokenModel } from './unregister-notification-token.model';

const apiUrl = `/api/notification-tokens`;

export const notificationTokenClient = {
  async register(body: RegisterNotificationTokenModel) {
    await baseClient.body<RegisterNotificationTokenModel, void>({
      url: `${apiUrl}`,
      method: 'PUT',
      body,
    });
  },

  async unregister(body: UnregisterNotificationTokenModel) {
    await baseClient.body<UnregisterNotificationTokenModel, void>({
      url: `${apiUrl}`,
      method: 'DELETE',
      body,
    });
  },
};
